// extracted by mini-css-extract-plugin
export default {"block":"Content_block__5IKmY"};